import { STATUS_CREATED, STATUS_CREATED_CODE } from "../constants/constant";
import { CHILDREN_COLUMNS_KEY, MAIN_FORM_KEY, MAIN_ROW_KEY } from "./interface";

interface RowKeyProps {
  mainKey?: string;
  childrenKey?: string;
};

/**
 * 解析唯一标识
 * @param rowKey 行数据的唯一标识
 * @returns 
 */
export function formatRowKey(rowKey?: string): RowKeyProps {
  const rowKeys: RowKeyProps = {};
  if (!rowKey) return rowKeys;
  const keyArr = rowKey.split('-');
  rowKeys.mainKey = keyArr[0];
  rowKeys.childrenKey = keyArr[1] ?? MAIN_FORM_KEY;
  return rowKeys;
}
/**
 * 根据数据转换成表单字段名
 * @param name 
 * @param mainKey 
 * @param childrenKey 
 */
export function formatFormItemName(name: string | string[], mainKey: string, childrenKey: string = MAIN_FORM_KEY) {
  if (Array.isArray(name)) {
    return name.map(item => {
      return [mainKey, childrenKey, item];
    });
  }
  return [mainKey, childrenKey, name];
}
/**
 * 获取最新的行数据
 * @param mainKey 主表key
 * @param childrenKey 子表key
 * @param formData 当前行表单最新数据集
 * @param dataSource 表格数据
 * @returns 
 */
export function getRowDataSource(mainKey: string, childrenKey: string, formData: any, dataSource?: any[]) {
  const findGroup = dataSource?.find(item => item.key === mainKey);
  if (!findGroup) return;
  if (childrenKey === MAIN_FORM_KEY) {
    return {
      ...findGroup,
      ...formData,
    };
  }
  const findChildren = findGroup.children?.find?.((item: any) => item.key === childrenKey);
  return {
    ...findChildren,
    ...formData,
  };
}
/**
 * 移除dataSource数据中的内部属性
 * @param dataSource 表格数据
 * @param filterDeleteData 是否过滤空数据
 * @param filterKey 是否过滤内部添加的属性
 * @returns 
 */
export function formatDataSource(dataSource?: any[], filterDeleteData?: boolean, filterKey?: boolean) {
  const newDataSource: any[] = [];
  dataSource?.forEach?.(group => {
    if (filterDeleteData && group[STATUS_CREATED_CODE] === STATUS_CREATED.DELETE) return;
    const { children, ...newGroup } = group;
    if (filterKey) {
      Reflect.deleteProperty(newGroup, 'key');
      Reflect.deleteProperty(newGroup, MAIN_ROW_KEY);
      Reflect.deleteProperty(newGroup, CHILDREN_COLUMNS_KEY);
    }
    if (Array.isArray(children) && children.length) {
      const newChildren: any[] = [];
      children.forEach(item => {
        const newItem = {...item};
        if (filterDeleteData && item[STATUS_CREATED_CODE] === STATUS_CREATED.DELETE) return;
        if (filterKey) {
          Reflect.deleteProperty(newItem, 'key');
        }
        newChildren.push(newItem);
      });
      newGroup.children = newChildren;
    }
    newDataSource.push(newGroup);
  });
  return newDataSource;
}
/**
 * 过滤已删除数据
 * @param dataSource 
 * @returns 
 */
export function filterDeleteData(dataSource?: any[]): any[] {
  const effectiveDataSource: any[] = [];
  if (Array.isArray(dataSource) && dataSource.length) {
    dataSource.forEach(item => {
      if (item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE) {
        const children = item.children;
        let effectiveChildren: any[] = []
        if (Array.isArray(children)) {
          children.forEach(child => {
            if (child[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE) {
              effectiveChildren.push(child);
            }
          });
        }
        effectiveDataSource.push({
          ...item,
          children: effectiveChildren,
        });
      }
    });
  }
  return effectiveDataSource;
}
